import { useRef } from 'react';
import { FaGooglePlay, FaApple } from 'react-icons/fa';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import './PlayStoreIcon.css';

function PlayStoreIcon() {
  const { sectionRef, isVisible } = useIntersectionObserver();

  return (
    <section id="download" className="playstore-section" ref={sectionRef}>
      <div className="playstore-wrapper">
        <h2 className={`playstore-title ${isVisible ? 'animate' : ''}`}>
          Start your smart recharge journey today!
        </h2>
        
        <p className={`playstore-subtitle ${isVisible ? 'animate' : ''}`}>
          Get the RSKPay App on Android and iOS. Manage all your payments with ease.
        </p>
        
        <div className={`playstore-buttons ${isVisible ? 'animate' : ''}`}>
          <a 
            href="https://app.rskpay.in" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="app-button google-play"
            aria-label="Download on Google Play"
          >
            <FaGooglePlay className="button-icon" />
            <div className="button-text">
              <span className="button-label">Get it on</span>
              <span className="button-store">Google Play</span>
            </div>
          </a>
          
          <a 
            href="https://app.rskpay.in" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="app-button app-store"
            aria-label="Download on App Store"
          >
            <FaApple className="button-icon" />
            <div className="button-text">
              <span className="button-label">Download on the</span>
              <span className="button-store">App Store</span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}

export default PlayStoreIcon;
